<div>
    <div class="form-subsection-container custom-page-row">
        <div class="page-title">
                    <img src="assets/icons/cogs.svg">
                    <div>Asset Management</div>
        </div>
        <div class="action-item">
            <button class="default-custom-button" mat-stroked-button id="edit" type="submit" (click)="exportDevicesToCSV()">
                <div>
                    Export
                </div>
            </button>
            <button mat-flat-button (click)="openDeviceModal()" class="default-custom-button add-button">Add Device</button>
        </div>
    </div>

    <div class="page-controls">
        <form [formGroup]="form">
                <div class="free-search page-options custom-page-row">
                    <free-search formControlName = "search" [searchOptions]="searchOptions"></free-search>
                    <button mat-button class="primary" id="edit" type="submit" (click)="resetFilters()">
                      Reset Filters
                    </button>
                </div>
                <div class="page-options form-subsection-container small-screen-subsection custom-page-row">
                    <div class="additional-filters">
                        <span>Filters:</span>
                        <mat-form-field class="custom-form-field customer-dropdown device-search" subscriptSizing="dynamic">
                            <mat-select title="Customer" formControlName="customerId" ngDefaultControl>
                                <mat-option class="custom-dropdown-item" [value]="'-1'">All Customers</mat-option>
                                <mat-option class="custom-dropdown-item" *ngFor="let customer of customers" [value]="customer.id">{{customer.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <span>
                            <label class="switch">
                                <input type="checkbox" formControlName="onlyFilterEnabled">
                                <span class="slider round"></span>
                            </label>
                            <span class="show-only-label">Show Only</span>
                            <mat-form-field class="custom-form-field default-custom-dropdown device-search" subscriptSizing="dynamic">
                                <mat-select title="Customer" ngDefaultControl formControlName="onlyFilter">
                                    <mat-option class="custom-dropdown-item" [value]="'onlyOnline'">Online Assets</mat-option>
                                    <mat-option class="custom-dropdown-item" [value]="'hasAvailableLogs'">Available Logs</mat-option>
                                    <mat-option class="custom-dropdown-item" [value]="'onlySelected'">Selected Assets</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </span>
                    </div>
                    <div class="actions">
                        <span class="action-item">
                            <span style="margin-top: 11px;">
                                Actions:
                            </span>
                            <mat-form-field class="custom-form-field default-custom-dropdown firmware-dropdown device-search" subscriptSizing="dynamic">
                                <mat-select title="Firmware" ngDefaultControl [(value)]="selectedFirmware">
                                    <mat-option class="custom-dropdown-item" [value]="-1">Select Firmware</mat-option>
                                    <mat-option class="custom-dropdown-item" *ngFor="let file of firmwareFiles" [title]="file.fileName" [value]="file.id">{{file.fileName}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div class="split-upgrade-button" matTooltip="Devices can only be upgraded if they are online." [matTooltipPosition]="'above'">
                                <button class="default-custom-button upgrade-firmware-btn split-upgrade-main" mat-flat-button id="edit" type="submit" [disabled]="upgradeDisabled" (click)="upgradeFirmware()">
                                  {{ selectedUpgradeType === 1 ? 'Upgrade on Next Reboot' : 'Upgrade Now' }}
                                </button>
                                <custom-dropdown-list-container class="split-upgrade-caret" [(isDropdownOpen)]="upgradeMenuOpen">
                                    <div dropdown-toggle class="split-upgrade-caret-toggle" [class.split-upgrade-disabled]="upgradeDisabled">
                                        <i class="custom-arrow" [class.down]="!upgradeMenuOpen" [class.up]="upgradeMenuOpen"></i>
                                    </div>
                                    <div dropdown-list class="custom-dropdown-items split-upgrade-options custom-dropdown-light">
                                        <custom-menu-item [name]="'Upgrade on Next Reboot'" (executeEvent)="selectUpgradeType(1)"></custom-menu-item>
                                        <custom-menu-item [name]="'Upgrade Now'" (executeEvent)="selectUpgradeType(0)"></custom-menu-item>
                                    </div>
                                </custom-dropdown-list-container>
                            </div>
                        </span>
                        <div class="custom-separator"></div>
                        <span class="action-item">
                            <custom-menu class="custom-form-field default-custom-dropdown firmware-dropdown device-search" [tooltip]="'Please select a device in order to use actions.'" [menuTitle]="'More Actions'">
                                <custom-menu-item [name]="'Request Logs'" [iconPath]="'assets/icons/log-request.svg'" [disabled]="selectionOutOfRange" (executeEvent)="requestManyLogs()"></custom-menu-item>
                                <custom-menu-item [name]="'Download Logs'" [iconPath]="'assets/icons/download.svg'" [disabled]="downloadDisabled" (executeEvent)="downloadLogs()"></custom-menu-item>
                                <custom-menu-item [name]="'Reset Camera Ref'" [iconPath]="'assets/icons/union.svg'" [disabled]="resetCameraRefDisabled" (executeEvent)="resetManyCameraSnapshotReference()"></custom-menu-item>
                                <custom-menu-item [name]="'Request Ref Images'" [iconPath]="'assets/icons/union.svg'" [disabled]="selectionOutOfRange" (executeEvent)="requestManyCameraSnapshotReference()"></custom-menu-item>
                                <custom-menu-item [name]="'Force Recording Map Upload'" [iconPath]="'assets/icons/progress-upload.svg'" [disabled]="forceRecordingMapDisabled" (executeEvent)="forceRecordingMapUpload()"></custom-menu-item>
                            </custom-menu>
                            <div matTooltip="Opens a dialog box which allows you to bulk update the selected devices" [matTooltipPosition]="'above'">
                                <button class="default-custom-button log-button" mat-stroked-button id="edit" type="submit" [disabled]="selectionOutOfRange || selectedDevices.length < 2" (click)="openBulkEdit()">
                                    <div>
                                        Bulk Edit
                                    </div>
                                </button>
                            </div>
                        </span>
                        <div class="custom-separator"></div>
                        <span class="action-item">
                            <div matTooltip="Delete Selected Assets" [matTooltipPosition]="'above'">
                                <button class="default-custom-button delete-button" mat-stroked-button id="edit" type="submit" [disabled]="selectionOutOfRange" (click)="deleteDevices()">
                                    <svg class="custom-button-icon" width="16" height="18" viewBox="0 0 16 18" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5 0V1H0V3H1V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H13C13.5304 18 14.0391 17.7893 14.4142 17.4142C14.7893 17.0391 15 16.5304 15 16V3H16V1H11V0H5ZM3 3H13V16H3V3ZM5 5V14H7V5H5ZM9 5V14H11V5H9Z"/>
                                    </svg>
                                    <div>
                                        Delete
                                    </div>
                                </button>
                            </div>
                        </span>
                    </div>
                </div>
        </form>
    </div>
    <div class="table-actions custom-page-row">
        <div class="device-count-message">{{selectedDevices.length}} Item{{selectedDevices.length > 1 || selectedDevices.length < 1 ? 's' : ''}} Selected</div>
        <div class="custom-separator"></div>
        <button mat-button class="primary clear-selection" color="primary" id="edit" type="submit" (click)="clearSelection()">
          Clear Selection
        </button>
    </div>

    <span class="ml-2 badge badge-dark d-none d-sm-inline" *ngIf="filtered">Results are being filtered</span>

    <div class="position-relative">
        <div class="loading-shade" *ngIf="isLoadingResults">
            <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
        </div>
        <h5 class="no-results text-center font-weight-bold py-3" *ngIf="resultsLength == 0 && !isLoadingResults">
            No Devices Found
        </h5>
        <div class="table-container device-table-container">
            <table mat-table [dataSource]="dataSource" matSort [class.d-none]="resultsLength == 0" style="width: fit-content">
                <!-- Select Column -->
                <ng-container matColumnDef="select">
                    <th mat-header-cell class="select-header frozen-header" *matHeaderCellDef matTooltip="Only the first {{selectedDevicesLimit}} assets in the list will be selected" [matTooltipPosition]="'above'" [style.width]="getColumnWidth('select')">
                        <mat-checkbox [checked]="selectBatchChecked" (click)="selectBatchToggled($event.target.checked)"></mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let device" class="select-cell frozen-cell" [class.highlighted-row]="getDeviceSelected(device.id)">
                        <mat-checkbox (click)="toggleSelected(device)" [checked]="getDeviceSelected(device.id)" [disabled]="selectDisabled(device.id)"></mat-checkbox>
                    </td>
                </ng-container>

                <!-- SerialNumber Column -->
                <ng-container matColumnDef="serialNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="first-column serial-no-header frozen-header" [style.width]="getColumnWidth('serialNumber')">{{columnDefinitions.get('serialNumber')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device" class="first-column serial-no-content serial-no-cell frozen-cell" [class.highlighted-row]="getDeviceSelected(device.id)" [title]="device.serialNumber ?? ''">
                        {{ device.serialNumber }}
                    </td>
                </ng-container>

                <!-- Buttons Column -->
                <ng-container matColumnDef="buttons">
                    <th mat-header-cell *matHeaderCellDef class="edit-header frozen-header" [style.width]="getColumnWidth('buttons')"><div>Edit</div></th>
                    <td mat-cell *matCellDef="let device" class="edit-cell frozen-cell" [class.highlighted-row]="getDeviceSelected(device.id)">
                        <a (click)="openDeviceModal(device)"> <img class="edit-icon" src="assets/icons/pencil.svg" /></a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="deviceId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="This ID is extracted from the health payload sent from the asset." [matTooltipPosition]="'above'" [style.width]="getColumnWidth('deviceId')">{{columnDefinitions.get('deviceId')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device" [title]="device.deviceId ?? ''">
                        {{ device.deviceId }}
                    </td>
                </ng-container>

                <!-- Customer Name Column -->
                <ng-container matColumnDef="customer">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('customer')">{{columnDefinitions.get('customer')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device" [title]="device?.customer?.name ?? ''">
                        {{ device?.customer?.name }}
                    </td>
                </ng-container>

                <!-- Fleet Id Column -->
                <ng-container matColumnDef="fleetId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('fleetId')">{{columnDefinitions.get('fleetId')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device" [title]="device.fleetId ?? ''">
                        {{ device.fleetId }}
                    </td>
                </ng-container>

                <!-- Online Column -->
                <ng-container matColumnDef="online">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('online')">{{columnDefinitions.get('online')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device">
                        <div class="shift-centered-data">
                            <div *ngIf="device.online;else offline_content" class="cell-content-wrapper"><div class="online custom-badge"></div>Online</div>
                            <ng-template #offline_content>
                                <div class="cell-content-wrapper"><div class="offline custom-badge"></div>Offline</div>
                            </ng-template>
                        </div>
                    </td>
                </ng-container>

                <!-- Last Seen Column -->
                <ng-container matColumnDef="lastPinged">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('lastPinged')">{{columnDefinitions.get('lastPinged')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device" class="cell-with-icon">
                        <div>
                            <p>{{ getFormattedDateTimeString(device.lastPinged) }}</p>
                            <custom-tooltip *ngIf="getLastSeenIcon(device.lastPinged) as lastSeenIcon" [tooltipMessage]="getLastSeenTooltip(device.lastPinged)">
                                <img [src]="lastSeenIcon" alt="last-seen-flag" tooltip-hoverable />
                            </custom-tooltip>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="assetType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('assetType')">{{columnDefinitions.get('assetType')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device" [title]="device.assetType?.name ?? ''">
                        {{ device.assetType?.name }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="assetGroupPath">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('assetGroupPath')">{{columnDefinitions.get('assetGroupPath')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device" [title]="device.assetGroupPath ?? ''">
                        {{ device.assetGroupPath }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="firmware">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('firmware')">{{columnDefinitions.get('firmware')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device">
                        {{ device.firmware }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="hwVer">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('hwVer')">{{columnDefinitions.get('hwVer')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device" [title]="device.hwVer ?? ''">
                        {{ device.hwVer }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="sim">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('sim')">{{columnDefinitions.get('sim')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device" [title]="device.sim ?? ''">
                        {{ device.sim }}
                    </td>
                </ng-container>

                <!-- Enabled Column -->
                <ng-container matColumnDef="enabled">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('enabled')">{{columnDefinitions.get('enabled')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device">
                        <ng-container *ngIf="device.enabled"><img class="true-icon" src="assets/icons/tick.svg" /></ng-container>
                    </td>
                </ng-container>

                <!-- enableRecordingMapRequest Column -->
                <ng-container matColumnDef="enableRecordingMapRequest">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('enableRecordingMapRequest')">{{columnDefinitions.get('enableRecordingMapRequest')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device">
                        <ng-container *ngIf="device.enableRecordingMapRequest"><img class="true-icon" src="assets/icons/tick.svg" /></ng-container>
                    </td>
                </ng-container>

                <!-- enableCamerasSnapshotRequest Column -->
                <ng-container matColumnDef="enableCamerasSnapshotRequest">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('enableCamerasSnapshotRequest')">{{columnDefinitions.get('enableCamerasSnapshotRequest')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device">
                        <ng-container *ngIf="device.enableCamerasSnapshotRequest"><img class="true-icon" src="assets/icons/tick.svg" /></ng-container>
                    </td>
                </ng-container>

                <!-- Logs Request Column -->
                <ng-container matColumnDef="logsRequest">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="getColumnWidth('logsRequest')">{{columnDefinitions.get('logsRequest')?.displayName}}</th>
                    <td mat-cell *matCellDef="let device">
                        <div class="cell-content-wrapper" *ngIf="device.logsRequest"
                             [matTooltip]="getLogStatusTooltip(device.logsRequest)"
                             matTooltipClass="multiline-tooltip"
                             [matTooltipPosition]="'above'" >
                            <div class="custom-chip" [class.ready]="getLogStatus(device.logsRequest) === 'Ready'" [class.requested]="getLogStatus(device.logsRequest) === 'Requested...'">
                                {{getLogStatus(device.logsRequest)}}
                            </div>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.highlighted-row]="getDeviceSelected(row.id)"></tr>
            </table>
        </div>

        <mat-paginator class="flex-grow-1" [length]="resultsLength" [pageSize]="25"
            [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
</div>

<ng-container *ngIf="bulkEditing == true">
    <bulk-edit-device-modal [devices]="selectedDevices" [triggerRefresh]="forceTableRefresh" [customers]="customers"
        (close)="modalClosed()"></bulk-edit-device-modal>
</ng-container>

<ng-container *ngIf="addingDevice == true">
    <device-form-modal [deviceId]="activeDevice?.id" [triggerRefresh]="forceTableRefresh" [customers]="customers"
        (close)="modalClosed()"></device-form-modal>
</ng-container>